// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getRemoteConfig } from "firebase/remote-config";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_srcJbSRuoqVdERKgUXDWssUrnTqEMPk",
  authDomain: "app.cosmicup.me",
  databaseURL: "https://chatupweb-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "chatupweb",
  storageBucket: "chatupweb.appspot.com",
  messagingSenderId: "882385694383",
  appId: "1:882385694383:web:9bc4c3a7cf90e26ab36e5a",
  measurementId: "G-31KR96FGMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const realTimeDB = getDatabase(app);
const analytics = getAnalytics(app);
let remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 10000; // 1 hour


export {app, db, analytics, realTimeDB, remoteConfig};